<template>
  <div
    :class="[
      'ss__custom__header__search',
      { 'ss__custom__header__searching': visible }]"
      @click.stop>
    <SsButton2
      type="text"
      class="ss__custon__header__btn__search"
      @click="show">
      <i class="ssCommunityIcon__search"/>
    </SsButton2>

    <transition name="ss__desktop__submenu__animation">
      <div
        v-show="visible"
        class="ss__custom__header__search__input__wrapper">
        <SsInput
          ref="input"
          :class="['ss__custom__header__search__input', 'comp__SsInput', {'comp__SsInput--clear': !!keyword}]"
          placeholder="搜索少数派…"
          v-model="keyword"
          @enter="onSearch">
          <template v-slot:prepend>
            <i class="ssCommunityIcon__search"/>
          </template>
          <template v-slot:append>
            <SsButton2
              type="text"
              class="btn__search__clear"
              @click="onClearSearch">
              <i class="ssCommunityIcon__error"/>
            </SsButton2>
          </template>
        </SsInput>
        <transition name="history__collpase__animation">
          <div v-if="history.length" ref="history" class="ss__custom__header__search__history__wrapper">
            <div class="ss__custom__header__search__history__inner">
              <div class="ss__custom__header__search__history__label">
                <span>搜索历史</span>
                <SsButton2
                  type="text"
                  :class="[
                    'btn__delete__search__history',
                    {'btn__delete__search__history--danger': deleteConfirm}
                  ]"
                  @click="onDeleteSearchHistory"
                  @blur.native="obBtnDeleteBlur">
                  <i class="ssCommunityIcon__delete"/>
                  <span v-if="deleteConfirm">清除历史</span>
                </SsButton2>
              </div>
              <div class="ss__custom__header__search__history">
                <span
                  class="ss__custom__header__search__history__item"
                  v-for="item in history"
                  :key="item"
                  @click="onSearch(item)">
                  {{ item }}
                </span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>

    <transition name="ss__custom__header__fade">
      <div
        v-show="visible"
        class="ss__custom__header__search__mask"
        @click="close"
      ></div>
    </transition>
  </div>
</template>

<script>
import SsButton2 from '../../../SsButton2'
import SsInput from '../../../SsInput'
export default {
  name: 'SsCustomHeaderSearch',

  components: {
    SsButton2,
    SsInput
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    searchUrl: String
  },

  data () {
    return {
      keyword: '',
      history: [],
      deleteConfirm: false,
      observer: null
    }
  },

  methods: {
    isMacOS () {
      if (typeof navigator === 'undefined') return false
      const platform = navigator.userAgentData?.platform || navigator.platform || ''
      return /Mac|iPod|iPhone|iPad/i.test(platform)
    },
    onClearSearch () {
      this.keyword = ''
    },
    onSearch (value) {
      this.close()
      value = encodeURIComponent(value)
      this.$bus?.$emit('gtag', 'view_search_results', { 'search_term': value })
      this.setSearchHistory(value)
      this.$openLink(this.searchUrl.replace('[keyword]', value))
    },
    show () {
      this.$emit('update:visible', true)
      this.$nextTick(() => {
        this.$refs.input.focus()
        this.updateHeightProperty(this.$refs.history)
      })
      setTimeout(() => {
        document.body.addEventListener('click', this.close)
      }, 300)
      dispatchEvent(new CustomEvent('ssCustomHeaderToggleTarget', { detail: 'search' }))
    },
    close () {
      this.onClearSearch()
      this.$emit('update:visible', false)
      document.body.removeEventListener('click', this.close)
    },
    handleShortcut (event) {
      const key = event.key && event.key.toLowerCase()
      const isMac = this.isMacOS()
      const isShortcut = key === 'k' &&
        !event.shiftKey &&
        !event.altKey &&
        (isMac ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey)

      if (isShortcut) {
        event.preventDefault()
        if (this.visible) {
          this.close()
        } else {
          this.show()
        }
      }
      if (event.key === 'Escape') {
        this.close()
      }
    },
    getSearchHistory () {
      try {
        const history = window.localStorage.getItem('ss_search_history')
        if (history) {
          this.history = history.split(',').filter(item => !!item).map(item => decodeURIComponent(item))
        }
      } catch (error) {
        console.log(error)
        window.localStorage.setItem('ss_search_history', '')
      }
    },
    setSearchHistory (v) {
      if (v && !this.history.includes(decodeURIComponent(v))) {
        v = decodeURIComponent(v)
        this.history = [v, ...this.history]
        this.history = this.history.slice(0, 10)
      }
      window.localStorage.setItem('ss_search_history', this.history.join(','))
    },
    onDeleteSearchHistory () {
      if (this.deleteConfirm) {
        this.history = []
        this.setSearchHistory()
        this.deleteConfirm = false
        return
      }
      this.deleteConfirm = true
    },
    obBtnDeleteBlur () {
      this.deleteConfirm = false
    },
    updateHeightProperty (element) {
      if (!element) return
      const height = element.scrollHeight
      element.style.setProperty('--height', `${height}px`)
    }
  },

  watch: {
    history: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          this.updateHeightProperty(this.$refs.history)
        })
      }
    }
  },

  mounted () {
    this.getSearchHistory()
    document.addEventListener('keydown', this.handleShortcut)
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.handleShortcut)
  }
}
</script>

<style lang="stylus" scoped>
.ss__custom__header__search {
  .ss__custon__header__btn__search {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnSearch, 32px);
    height: var(--h-ssCustonHeaderBtnSearch, 32px);
    i {
      font-size: var(--size-ssCustonHeaderSearchIcon, 20px);
      color: var(--color-ssCustonHeaderSearchIcon, var(--B8-t));
    }
  }
}

.ss__custom__header__searching {
  z-index: 1;
}

.ss__custom__header__search__input__wrapper {
  position: fixed;
  overflow: auto;
  z-index: 9;
  background: var(--B0-t);
  width: 620px;
  border-radius: 16px;
  left: calc((100vw - 620px) / 2);
  top: 140px;
  box-shadow: var(--shadow-level-2);
}

.ss__custom__header__search__mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--color-backdrop);
}

.ss__custom__header__search__input.comp__SsInput {
  --outline-ssInput: none;
  --inset-ssInput: 8px 0;
  --radius-ssInput: 0px;
  --color-ssInputPlaceholder: var(--B6-t);
  --color-ssInput-default: var(--B6-t);
  caret-color: var(--brand);
  font-size: 15px;
  font-weight: 500;
  line-height: 21px;
  height: 45px;
  padding: 12px;
  margin: 4px;
  width: 612px;
  box-sizing: border-box;
  background: var(--B2-t);
  border-radius: 12px;
  .ssCommunityIcon__search {
    font-size: 20px;
    color: var(--B6-t);
  }
  .btn__search__clear {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: var(--B6-t);
    &::before {
      background: transparent;
    }
  }
  >>> .ss__input__prepend {
    padding-right: 0;
    margin-right: 8px;
    transition: .2s;
    &::after {
      display: none;
    }
  }
  >>> .ss__input__append {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0s, opacity 0.2s 0s;
  }
  >>> &.ss__input__wrapper--focus {
    .ss__input__prepend {
      color: var(--B8-t);
    }
  }
  &.comp__SsInput--clear {
    >>> .ss__input__append {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s 0.2s, opacity 0.2s 0s;
    }
  }
  >>> .ss__input::placeholder {
    font-weight: 500;
  }
}

.ss__desktop__submenu__animation-enter-active,
.ss__desktop__submenu__animation-leave-active {
  transform: translateY(0px);
  opacity: 1;
  transition all .3s var(--a-func-default)
}
.ss__desktop__submenu__animation-enter,
.ss__desktop__submenu__animation-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

.ss__custom__header__search__history__inner {
  margin: 4px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}
.ss__custom__header__search__history__label {
  font-size: 13px;
  color: var(--B6-t);
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ss__custom__header__search__history {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.ss__custom__header__search__history__item {
  font-size: 13px;
  color: var(--B8-t);
  padding: 6px 8px;
  border-radius: 6px;
  background: var(--B1-t);
  cursor: pointer;
}

.btn__delete__search__history {
  color: var(--B6-t);
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  i {
    font-size: 20px;
  }
  &.btn__delete__search__history--danger {
    color: var(--red-t);
    span {
      font-weight: 500;
    }
  }
}

.history__collpase__animation-enter-active,
.history__collpase__animation-leave-active {
  height: var(--height);
  opacity: 1;
  transition: height .36s var(--a-func-default),opacity .36s var(--a-func-default);
}
.history__collpase__animation-enter,
.history__collpase__animation-leave-to {
  opacity: 0;
  height: 0px;
}
</style>
